"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var React = __importStar(require("react"));
var app_1 = require("../app");
var nav_1 = __importDefault(require("../components/nav"));
var page_1 = __importDefault(require("../components/page"));
var useContext = React.useContext, useEffect = React.useEffect;
exports.default = (function (_a) {
    var settings = _a.settings, shippingIntervalFrequencies = _a.shippingIntervalFrequencies, shippingIntervalUnitType = _a.shippingIntervalUnitType;
    var context = useContext(app_1.AppContext);
    if (!context) {
        return null;
    }
    var handleChangeShippingFrequencyClick = context.handleChangeShippingFrequencyClick, selShippingFrequency = context.selShippingFrequency, selDiscountAddOns = context.selDiscountAddOns, isTestingExpandedMobileLayout = context.isTestingExpandedMobileLayout, handleExpandedMobileLayoutSetup = context.handleExpandedMobileLayoutSetup;
    useEffect(function () {
        var _a;
        if (isTestingExpandedMobileLayout) {
            handleExpandedMobileLayoutSetup();
        }
        var selectedAddOns = selDiscountAddOns.map(function (da) { return da.name; });
        var addOnTotal = (0, sumBy_1.default)(selDiscountAddOns, 'price');
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'diaperBundle__frequency', selectedAddOns: selectedAddOns, addOnTotal: addOnTotal });
    });
    return (React.createElement(page_1.default, { renderNav: React.createElement(nav_1.default, { canGoNext: !!selShippingFrequency, centerContent: React.createElement(React.Fragment, null) }) },
        React.createElement("div", { className: 'bundler-app-select-frequency padding-6 medium-padding-10 large-padding-horizontal-14 large-padding-vertical-8' },
            React.createElement("h1", { className: 'h3' }, settings.header),
            React.createElement("div", { className: 'margin-bottom-6 font-lighter' }, settings.subheader),
            React.createElement("div", { className: 'grid-x grid-margin-x grid-margin-y align-center margin-vertical-10' }, shippingIntervalFrequencies.map(function (frequency) { return (React.createElement("div", { className: 'cell small-4 medium-3 text-center', key: frequency },
                React.createElement("a", { className: (0, classnames_1.default)('frequency text-center flex-container align-middle align-center', selShippingFrequency === frequency && 'selected'), onClick: handleChangeShippingFrequencyClick(frequency) },
                    React.createElement("div", { className: 'lh1 padding-4' },
                        React.createElement("div", { className: 'large font-bold' }, frequency),
                        React.createElement("div", null, shippingIntervalUnitType))),
                React.createElement("div", { className: 'h7 text-gray margin-top-2' }, settings["frequency".concat(frequency, "Blurb")]))); })),
            React.createElement("div", { className: 'flex-container align-middle' },
                React.createElement("i", { className: 'ss-mail text-bonjour h5 padding-right-3 margin-bottom-0' }),
                React.createElement("span", { className: 'h7', dangerouslySetInnerHTML: { __html: settings.reminderCopy } })))));
});
